

export const errorMobile = 'Please enter correct mobile number';
export const errorPan = 'Please enter correct PAN';
export let rootUrl = 'https://jcbgenuinelubesuatapi.castrol.com/api/v1/';
//export let rootUrl = 'https://jcbgenuinelubesapi.castrol.com/api/v1/';
export const webservices = {
  getValidateNo: 'User/validateMobileNo/',
  getOtp: 'User/generateOtp/',
  getState: 'User/populateDropdown',
  getCity: 'User/populateDropdown',
  getTransactionType: 'User/populateDropdown',
  getUserDetail: 'User/getUserDetail/',
  getTransactionHistory: 'Payment/getTransactionHistory/',
  saveUserData: 'User/saveUserDetails',
  validateOtp: 'User/validateOTP',
  getPaymentMode: 'Payment/getPaymentMode',
  saveBankData: 'Payment/saveBankUPIDetail',
  deleteBankUpi: 'Payment/deleteBankUpiInfo',
  // saveMobileNo: '',
  scanCouponRegister: 'Payment/registerCouponScan',
  getUserType: 'User/populateDropdown',
  getTermsConditions: 'User/getTermsConditions/',
  getAppStatus: 'Service/getAppStatus',
  saveUserLogin: 'User/saveUserLogin',
  saveUserUsage: 'User/saveUserUsage',
  chkRedeemCouponAllow: 'Payment/chkRedeemCouponAllow',
  //saveTransaction: 'Payment/saveTransactionDetails'
  saveBankTransaction: 'Payment/saveBankTransaction',
  saveUpiTransaction: 'Payment/saveUpiTransaction',
  upiVerify: 'Payment/validateUpi',
  bankVerify: 'Payment/validateBankAccount',
  geoLocation: 'Service/getGeoLocation'


};
export const encryKey = "YTePLQfIj3A5jcYR8fg3fVx3BPw0DJpY";
export const encryText = "Jcbgenuinelubesapp";

export const regex = {
  phoneRegex: /^[6-9]\d{9}$/,
  passwordRegex:
    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{6,30}$/,
  cashRegex: /^\d{1,6}$/,
  //  nameRegex: /^[A-Za-z -]*[A-Za-z][A-Za-z][A-Za-z][A-Za-z -]*$/,
  nameRegex: /^[A-Za-z -]{3,}$/,
  // nameRegex: /^(?!\s*$)[A-Za-z]+$/,
  numberRegex: /^\d*$/,
  dateRegex: /^\d{4}\-\d{2}\-\d{2}$/,
  accountRegex: /^[A-Za-z0-9]{6,18}$/,
  ifscRegex: /^[A-Z]{4}0[A-Z0-9]{6}$/,
  pinRegex: /^[1-9]\d{4}[1-9]$/,
  nameRegexProfile: /^[A-Za-z -]{3,100}$/,
  upiIdRegex: /^[\w.-]+@[\w.-]+$/,
  couponCodeRegex: /^[0-9A-Z]{8}-[0-9A-Z]{4}-[0-9A-Z]{4}-[0-9A-Z]{4}-[0-9A-Z]{12}$/i
};
